<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-back-top ref="aa" />
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="学生名称">
              <a-input v-model="queryParam.name" placeholder="请输入学生姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="9" :sm="24">
            <j-dict-select-tag
              style="width: 100%"
              placeholder="请选择年级"
              v-model="queryParam.gradeId"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :allowClear="false"
              :isShowEmpty="false"
              @select="(record) => selectTag('grade', record)"
            />
          </a-col>
          <a-col :xl="4" :lg="6" :md="9" :sm="24">
            <j-dict-select-tag
              style="width: 100%"
              placeholder="请选择班级"
              v-model="queryParam.classId"
              :dictCode="
                'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
              "
              :async="true"
              :disabled="!queryParam.gradeId"
              :isShowEmpty="false"
              @select="(record) => selectTag('class', record)"
            />
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="表情分类">
              <j-dict-select-tag
                v-model="queryParam.emotion"
                placeholder="请选择"
                dictCode="total_emotion"
              />
            </a-form-item>
          </a-col>
          <!--          <a-col :xl="4" :lg="7" :md="8" :sm="24">-->
          <!--            <a-form-item label="数据查看">-->
          <!--              <a-select-->
          <!--                v-model="queryParam.showDataByEmotion"-->
          <!--                placeholder="请选择"-->
          <!--                allowClear-->
          <!--              >-->
          <!--                <a-select-option value="0">仅看未修改</a-select-option>-->
          <!--                <a-select-option value="1">仅看已修改</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="地点">
              <j-dict-select-tag
                v-model="queryParam.location"
                dictCode="gd_camera,camera_name,id"
                placeholder="请选择地点"
              />
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item label="时间范围">
              <a-range-picker
                :style="{ width: '256px' }"
                :value="rangeDate"
                :allowClear="false"
                @change="onRangeChange"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" style="margin-left: 8px" icon="search">
                查询
              </a-button>
              <a-button type="primary" @click="searchResetFrom" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="faceUrl" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片{{ text }}</span>
          <img
            v-else
            :src="getImgView(text)"
            @click="showImgDialog(getImgView(text))"
            height="150px"
            alt
            style="max-width: 150px; font-size: 12px; font-style: italic"
          />
        </template>

        <span v-has="'expressionCorrect:show'" slot="action" slot-scope="text, record">
          <a-button
            style="background: #00b300; color: white"
            @click="changeEmotion(record, 0, '微笑')"
          >
            微笑
          </a-button>
          <a-divider type="vertical" />
          <a-button type="danger" @click="changeEmotion(record, 1, '愤怒')">愤怒</a-button>
          <a-divider type="vertical" />
          <a-button type="primary" @click="changeEmotion(record, 6, '正常')">正常</a-button>
          <a-divider type="vertical" />
          <a-button
            style="background: black; color: white"
            @click="changeEmotion(record, -1, '未知')"
          >
            未知
          </a-button>
        </span>
      </a-table>
      <a-button type="primary" @click="changeAllEmotion()" style="float: right">
        本页判断无误
      </a-button>
    </div>
    <a-modal
      hoverable
      title="查看照片"
      :visible="imgboxModal"
      centered
      @cancel="() => ((imgModelSrc = ''), (imgboxModal = false))"
      width="50%"
      :footer="null"
    >
      <img :src="imgModelSrc" alt style="width: 100%" />
    </a-modal>
    <student-face-modal ref="modalForm" @ok="modalFormOk"></student-face-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import StudentFaceModal from './modules/StudentFaceModal'
import { httpAction } from '@api/manage'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import { mapGetters } from 'vuex'
import { AuthUtilMixin } from '@/mixins/AuthUtilMixin'

export default {
  name: 'StudentFaceList',
  mixins: [JeecgListMixin, mixinDevice, AuthUtilMixin],
  components: {
    StudentFaceModal,
    JSearchSelectTag,
  },
  data() {
    return {
      description: 'student_face管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '年级',
          align: 'center',
          dataIndex: 'gradeName',
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
        },
        {
          title: '图片',
          align: 'center',
          dataIndex: 'faceUrl',
          scopedSlots: { customRender: 'faceUrl' },
        },
        {
          title: '地点',
          align: 'center',
          dataIndex: 'cameraName',
          // gdCamera.cameraName
        },
        {
          title: '采集时间',
          align: 'center',
          dataIndex: 'createTime',
        },
      ],
      url: {
        list: '/aigoes/studentFace/list',
        delete: '/aigoes/studentFace/delete',
        deleteBatch: '/aigoes/studentFace/deleteBatch',
        exportXlsUrl: '/aigoes/studentFace/exportXls',
        importExcelUrl: 'aigoes/studentFace/importExcel',
      },
      dictOptions: {},
      imgboxModal: false,
      imgModelSrc: '',
      //查询数据范围
      rangeDate: [moment(), moment()],
      disableMixinCreated: true,
    }
  },
  created() {
    this.addActionColumn()
    // 默认查询今天的数据
    this.queryParam.beginDate = moment().format('YYYY-MM-DD')
    this.queryParam.endDate = moment().format('YYYY-MM-DD')
    this.loadData()
    this.initDictConfig()
  },
  computed: {
    ...mapGetters(['currUserActionAuth']),
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    searchResetFrom(){
      this.rangeDate = [moment(), moment()]
      this.queryParam = {}
      this.queryParam.beginDate = moment().format('YYYY-MM-DD')
      this.queryParam.endDate = moment().format('YYYY-MM-DD')
      this.loadData(1)
    },
    selectTag(type, record) {
      console.log('选择标签', record, type)
      switch (type) {
        case 'grade':
          this.$set(this.queryParam, 'classId', '')
          this.$set(this.queryParam, 'gradeId', record.value)
          this.currGradeName = record.text
          break
        case 'class':
          this.$set(this.queryParam, 'classId', record.value)
          this.currClassName = record.text
          break
      }
      // this.$set(this.formData, 'name', record.text)
    },
    initDictConfig() {},
    // 控制权限：是否新增操作列
    addActionColumn() {
      // 是否加入表情分析列
      if (this.hasBtnActionAuth('expressionAnalysis:show')) {
        this.columns.push({
          title: '表情分析',
          align: 'center',
          dataIndex: 'emotion_dictText',
        })
      }
      // 是否加入表情分析2列
      if (this.hasBtnActionAuth('expressionAnalysis2:show')) {
        this.columns.push({
          title: '表情分析2',
          align: 'center',
          dataIndex: 'aiEmotion_dictText',
        })
      }
      // 是否加入操作列
      if (this.hasBtnActionAuth('expressionCorrect:show')) {
        this.columns.push({
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        })
      }
    },
    showImgDialog(src) {
      console.log(src)
      this.imgboxModal = true
      this.imgModelSrc = src
    },
    changeEmotion(record, emotion, emotionText) {
      if (record.aiEmotion === '') {
        record.aiEmotion = record.emotion
        record.aiEmotion_dictText = record.emotion_dictText
      }
      record.emotion = emotion
      httpAction('/aigoes/studentFace/edit', record, 'put')
        .then((res) => {
          if (res.success) {
            this.dataSource.forEach((item) => {
              if (item.id === record.id) {
                item.emotion_dictText = emotionText
                item.emotion = emotion
              }
              return item
            })
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {})
    },
    //本页判断无误
    changeAllEmotion() {
      var ids = []
      this.dataSource.forEach((item) => {
        if (item.aiEmotion === '') {
          ids.push(item.id)
        }
      })
      httpAction('/aigoes/studentFace/editBatch', { ids: ids.toString() }, 'put').then((res) => {
        this.dataSource.forEach((item) => {
          if (item.aiEmotion === '') {
            item.aiEmotion_dictText = item.emotion_dictText
            item.aiEmotion = item.emotion
          }
          return item
        })
        this.$message.success(res.message)
        this.loadData()
      })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]

      this.loadData(1)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
